<template>
  <v-container>
    <v-dialog
      v-model="showDialog"
      max-width="900"
      persistent
      @keydown.esc="closeDialog()"
    >
      <v-card>
        <v-card-title class="header white--text py-4" dark>
          {{ $tc("nav.safety") }}
        </v-card-title>
        <v-layout>
          <!-- Sidebar -->
          <v-navigation-drawer v-model="drawer" permanent width="350">
            <v-list dense>
              <v-list-item-group active-class="primary--text">
                <v-list-item
                  v-for="item in sortedItems"
                  :key="item.id"
                  @click="onMenuSelect(item.id)"
                >
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-navigation-drawer>

          <v-container>
            <template v-if="selectedOption === 2">
              <v-card
                class="pa-4"
                outlined
                flat
                rounded="lg"
                v-show="showForgotPassword"
              >
                <p class="title font-weight-light ma-0 pb-4">
                  {{ $tc("nav.changePass") }}
                </p>
                <v-container class="pa-0">
                  <v-form ref="form">
                    <v-text-field
                      class="center"
                      v-model="password"
                      :placeholder="$tc('login.newPass')"
                      :type="showPassword ? 'text' : 'password'"
                      :rules="passwordRules"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showPassword = !showPassword"
                      :class="{ 'eye-icon-color': showPassword }"
                      required
                      dense
                      outlined
                      color="primary"
                    />
                    <v-text-field
                      class="center"
                      v-model="confirmPassword"
                      :placeholder="$tc('login.confirmPass')"
                      :type="showConfirmPassword ? 'text' : 'password'"
                      :rules="confirmPasswordRules"
                      :append-icon="
                        showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'
                      "
                      @click:append="showConfirmPassword = !showConfirmPassword"
                      :class="{ 'eye-icon-color': showConfirmPassword }"
                      required
                      dense
                      outlined
                      color="primary"
                    />
                  </v-form>
                </v-container>
                <v-alert
                  v-if="success"
                  type="success"
                  color="primary"
                  class="mt-3"
                  icon="mdi-check-circle"
                >
                  {{ $tc("login.passChanged") }}
                </v-alert>
                <v-card-actions v-if="!success" class="d-flex justify-end pa-0">
                  <v-btn
                    class="btn-transition primary"
                    @click="changePassword()"
                    :disabled="!valid"
                  >
                    {{ $tc("login.change") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>

            <template v-else-if="selectedOption === 1">
              <v-card class="pa-4" outlined flat rounded="lg">
                <p class="title font-weight-light ma-0 pa-0">
                  {{ $tc("nav.twoFactor") }}
                </p>
                <v-container class="pa-0">
                  <v-col class="pa-0 pb-4">
                    <v-card-title class="px-0 pb-1 subtitle-1" dark>
                      1.Generar el QR
                    </v-card-title>
                    <p class="ma-0">
                      Hace clic en el botón "GENERAR
                      <v-icon small color="black">fas fa-qrcode</v-icon>".
                    </p>
                    <v-card-title class="px-0 pb-1 subtitle-1" dark>
                      2.Abrir la app Google Authenticator
                    </v-card-title>
                    <p>
                      Descarga la app Google Authenticator desde la App Store o
                      Google Play.<br />
                      Ábrelo y selecciona el boton que diga "Agregar un código",
                      luego seleccionar "Escanear un código QR".<br />
                      Usa la cámara de tu teléfono para escanear el código QR
                      generado.
                    </p>
                  </v-col>
                  <v-row class="justify-space-between ma-auto">
                    <v-switch
                      class="ma-0 pa-0 my-auto"
                      @click="activeTwoFactor()"
                      v-model="twoFactor"
                      inset
                      :label="
                        twoFactor
                          ? $tc('nav.disabledTwoFactor')
                          : $tc('nav.enabledTwoFactor')
                      "
                      hide-details
                    />
                    <v-btn @click="generateTwoFactor()" class="primary">
                      Generar<v-icon right>fas fa-qrcode</v-icon>
                    </v-btn>
                  </v-row>

                  <v-img :src="imgQR.qr" width="200" class="mx-auto" />
                </v-container>
              </v-card>
            </template>
          </v-container>
        </v-layout>
        <v-row class="justify-center pa-0 ma-0">
          <v-btn
            class="btn-transition ma-2 pa-0"
            style="color: #e2504c"
            text
            @click="closeDialog()"
            >{{ $tc("newController.close") }}</v-btn
          >
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import login from "@/store/login/login";

export default {
  props: {
    show: Boolean,
  },
  data() {
    return {
      showDialog: false,
      drawer: true,
      selectedOption: 1,
      menuItems: [
        {
          id: 1,
          text: this.$tc("nav.twoFactor"),
          icon: "fas fa-shield-alt",
        },
      ],
      userSelected: null,
      password: "",
      confirmPassword: "",
      passwordRules: [
        (value) => !!value || this.$tc("login.passRequired"),
        (value) =>
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/.test(value) ||
          this.$tc("login.mustContainPass"),
        (value) =>
          /[!@#$%^&*(),.?":{}|<>]/.test(value) ||
          this.$tc("login.mustContainSpecial"),
        (value) =>
          (value && value.length >= 8) || this.$tc("login.mustLengthPass"),
      ],
      confirmPasswordRules: [
        (value) => !!value || this.$tc("login.confirmPassRequired"),
        (value) => value === this.password || this.$tc("login.passNoMatch"),
      ],
      valid: false,
      error: false,
      success: false,
      showPassword: false,
      showConfirmPassword: false,
      twoFactor: localStorage.getItem("active2fa") === "true" ? true : false,
      imgQR: "",
    };
  },
  watch: {
    password: function () {
      this.valid = this.$refs.form.validate();
    },
    confirmPassword: function () {
      this.valid = this.$refs.form.validate();
    },
  },
  computed: {
    showForgotPassword() {
      return (
        !process.env.VUE_APP_LOGINBYAD ||
        process.env.VUE_APP_LOGINBYAD === "false"
      );
    },
    sortedItems() {
      return this.menuItems.slice().sort((a, b) => a.id - b.id);
    },
  },
  methods: {
    async generateTwoFactor() {
      this.imgQR = await login.dispatch("avtiveTwoFactor");
      localStorage.setItem("active2fa", true);
      this.twoFactor = true;
    },
    async activeTwoFactor() {
      login.dispatch("updateTwoFactor", this.twoFactor).then(() => {
        localStorage.setItem("active2fa", this.twoFactor);
      });
    },
    closeDialog() {
      this.$emit("close");
    },
    onMenuSelect(id) {
      if (this.selectedOption !== id) {
        this.selectedOption = id;
      }
    },
    changePassword() {
      const operId = localStorage.getItem("operId");
      let payload = {
        id: operId,
        newPassword: this.confirmPassword,
        sendMail: false,
      };
      login
        .dispatch("changepass", payload)
        .then(() => {
          this.success = true;
          this.valid = false;
          setTimeout(() => {
            this.showDialog = false;
          }, 3000);
        })
        .catch((e) => {
          this.error = false;
        });
    },
  },
  async mounted() {
    this.showDialog = this.show;
    this.userSelected = await login.state.user;
    if (this.showForgotPassword) {
      this.menuItems.push({
        id: 2,
        text: this.$tc("nav.changePass"),
        icon: "fas fa-key",
      });
    }
  },
};
</script>
<style>
.title {
  font-size: 14px !important;
}
</style>
